// Left Sidebar Navigation Component
class LeftSidebar {
    constructor() {
        this.activeTab = 'dashboard';
        // Check if mobile - force collapsed on mobile
        this.isMobile = window.innerWidth <= 768;
        this.isCollapsed = this.isMobile ? true : (localStorage.getItem('sidebarCollapsed') === 'true');
        this.mobileHidden = this.isMobile ? (localStorage.getItem('sidebarMobileHidden') === 'true') : false;

        // Store account data for display
        this.currentAccountSummary = null;
        this.currentPositions = [];
        this.allAssetBalances = new Map(); // Store all asset holdings (USDC, USDH, spot tokens)

        this.tabs = [
            // HYPERLIQUID MODE TABS
            // Quick Access Section
            { section: 'TRADING', icon: '../icons/lightning.png', mode: 'hyperliquid' },
            { id: 'dashboard', label: 'Dashboard', icon: '../icons/home.png', section: 'quick', mode: 'hyperliquid' },
            { id: 'terminal', label: 'Trading Terminal', icon: '../icons/orders.png', section: 'quick', showBadge: 'positions', mode: 'hyperliquid' },
            { id: 'performance', label: 'Performance', icon: '../icons/performance.png', section: 'quick', mode: 'hyperliquid' },

            // Trading Section
            { section: 'SIGNALS AND ANALYTICS', icon: '../icons/chart.png', mode: 'hyperliquid' },
            { id: 'trades', label: 'AI Signals', icon: '../icons/ai.png', section: 'trading', showBadge: 'incomingTrades', mode: 'hyperliquid' },
            // { id: 'tracker', label: 'Symbol Tracker', iconSvg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19V5"/><path d="M4 19H20"/><path d="M7 19v-6"/><path d="M11 19v-10"/><path d="M15 19v-8"/><circle cx="19" cy="7" r="2.2"/><path d="M18.2 7.8l1.6-1.6"/><path d="M18.5 6.6h0.01"/><path d="M19.5 7.6h0.01"/></svg>', section: 'trading', mode: 'hyperliquid' },
            { id: 'funding', label: 'Funding Rates', icon: '../icons/chart.png', section: 'trading', mode: 'hyperliquid' },
            // { id: 'charts', label: 'Charting', icon: '../icons/chart.png', section: 'trading', mode: 'hyperliquid' },
            { id: 'user-feed', label: 'Positions & Orders', icon: '../icons/management.png', section: 'trading', showBadge: 'chaseCount', mode: 'hyperliquid' },

            // Automation Section
            { section: 'AUTOMATION', icon: '../icons/bot.png', mode: 'hyperliquid' },
            { id: 'bots', label: 'Bot Manager', icon: '../icons/bot.png', section: 'automation', showBadge: 'activeBots', mode: 'hyperliquid' },
            { id: 'stablecoin-mm', label: 'StableCoin MM', iconSvg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>', section: 'automation', showStatus: 'toggle', mode: 'hyperliquid' },
            { id: 'auto-trade', label: 'Auto Trade', icon: '../icons/lightning.png', section: 'automation', showStatus: 'toggle', mode: 'hyperliquid' },

            // System Section
            { section: 'SYSTEM', icon: '../icons/setting-lines.png', mode: 'hyperliquid' },
            { id: 'settings', label: 'Settings', icon: '../icons/setting-lines.png', section: 'system', mode: 'hyperliquid' },
            // { id: 'onboard', label: 'Onboard', icon: '../icons/info.png', section: 'system', mode: 'hyperliquid' },
            { id: 'about', label: 'About', icon: '../icons/info.png', section: 'system', mode: 'hyperliquid' },

            // LIGHTER MODE TABS - EXACT COPY OF HYPERLIQUID STRUCTURE
            // Quick Access Section
            { section: 'TRADING', icon: '../icons/lightning.png', mode: 'lighter' },
            { id: 'lighter-dashboard', label: 'Dashboard', icon: '../icons/home.png', section: 'lighter-quick', mode: 'lighter' },
            { id: 'lighter-terminal', label: 'Trading Terminal', icon: '../icons/orders.png', section: 'lighter-quick', showBadge: 'positions', mode: 'lighter' },
            { id: 'lighter-performance', label: 'Performance', icon: '../icons/performance.png', section: 'lighter-quick', mode: 'lighter' },

            // Trading Section
            { section: 'SIGNALS AND ANALYTICS', icon: '../icons/chart.png', mode: 'lighter' },
            { id: 'lighter-signals', label: 'AI Signals', icon: '../icons/ai.png', section: 'lighter-trading', showBadge: 'incomingTrades', mode: 'lighter' },
            { id: 'lighter-funding', label: 'Funding Rates', icon: '../icons/chart.png', section: 'lighter-trading', mode: 'lighter' },
            // { id: 'lighter-charts', label: 'Charting', icon: '../icons/chart.png', section: 'lighter-trading', mode: 'lighter' },
            { id: 'lighter-orders', label: 'Positions & Orders', icon: '../icons/management.png', section: 'lighter-trading', showBadge: 'chaseCount', mode: 'lighter' },

            // Automation Section
            { section: 'AUTOMATION', icon: '../icons/bot.png', mode: 'lighter' },
            { id: 'lighter-bots', label: 'Bot Manager', icon: '../icons/bot.png', section: 'lighter-automation', showBadge: 'activeBots', mode: 'lighter' },
            { id: 'lighter-stablecoin-mm', label: 'StableCoin MM', iconSvg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>', section: 'lighter-automation', showStatus: 'toggle', mode: 'lighter' },
            { id: 'lighter-auto-trade', label: 'Auto Trade', icon: '../icons/lightning.png', section: 'lighter-automation', showStatus: 'toggle', mode: 'lighter' },

            // System Section
            { section: 'SYSTEM', icon: '../icons/setting-lines.png', mode: 'lighter' },
            { id: 'lighter-settings', label: 'Settings', icon: '../icons/setting-lines.png', section: 'lighter-system', mode: 'lighter' },
            // { id: 'lighter-onboard', label: 'Onboard', icon: '../icons/info.png', section: 'lighter-system', mode: 'lighter' },
            { id: 'lighter-about', label: 'About', icon: '../icons/info.png', section: 'lighter-system', mode: 'lighter' }
        ];
        this.onTabChange = null;
        this.badgeData = {
            positions: 0,
            notifications: 0,
            incomingTrades: 0,
            activeBots: 0,
            chaseCount: 0
        };
        this.statusData = {
            bot: false,
            autoTrade: false,
            autoTradeMode: 'easy',  // Track mode: 'easy' or 'hard'
            stablecoinMM: false
        };
        this.statusUpdateInterval = null;
        this.positionsDataHandler = null;
        this.init();
        this.startStatusUpdates();
        this.setupPositionsListener();
        this.setupChaseListener();
        this.setupResizeListener();
    }

    /**
     * Initialize the sidebar
     */
    init() {
        this.render();
        this.setupEventListeners();

        // Initial check for settings requirement (missing API key)
        // Delay slightly to ensure PasswordManager is ready
        setTimeout(() => {
            if (this.checkSettingsRequirement) {
                this.checkSettingsRequirement();
            }
        }, 2000);

        // Re-check periodically
        setInterval(() => {
            if (this.checkSettingsRequirement) {
                this.checkSettingsRequirement();
            }
        }, 10000);
    }

    /**
     * Render the sidebar HTML
     */
    render() {
        const sidebar = document.getElementById('left-sidebar');
        if (!sidebar) {
            console.error('Left sidebar container not found');
            return;
        }

        // Get current mode from ModeManager
        const currentMode = window.ModeManager?.currentMode || 'hyperliquid';

        sidebar.innerHTML = `
            <div class="sidebar-header">
                <img src="../icons/1.svg" class="sidebar-logo" alt="EV+">
                <img src="../../assets/atv4Nobg.png" class="sidebar-logo-collapsed" alt="ATV4">
                ${!this.isMobile ? `<button class="sidebar-toggle-btn" id="sidebar-toggle-btn" title="${this.isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="${this.isCollapsed ? 'M9 18l6-6-6-6' : 'M15 18l-6-6 6-6'}" />
                    </svg>
                </button>` : ''}
            </div>
            <!-- COMMENTED OUT: Mode switcher buttons
            <div class="sidebar-mode-switcher">
                <button class="sidebar-mode-btn ${currentMode === 'hyperliquid' ? 'active' : ''}" data-mode="hyperliquid">
                    <span class="mode-label">Hyperliquid</span>
                </button>
                <button class="sidebar-mode-btn ${currentMode === 'lighter' ? 'active' : ''}" data-mode="lighter">
                    <span class="mode-label">Lighter</span>
                </button>
            </div>
            -->
            <div class="sidebar-tabs">
                ${this.renderTabsWithSections()}
            </div>
            <div class="sidebar-footer-enhanced">
                <div class="connection-indicator">
                    <span class="status-dot connected" id="sidebar-status-dot"></span>
                    <span class="sidebar-status-text" id="sidebar-status-text">Connected</span>
                    <span class="sidebar-time" id="sidebar-time">--:--</span>
                </div>
                
                <div class="footer-stats">
                    <div class="sidebar-stat-item">
                        <div class="sidebar-stat-content">
                            <span class="sidebar-stat-label">Account</span>
                            <span class="sidebar-stat-value" id="sidebar-account-value">$0.00</span>
                        </div>
                    </div>
                    <div class="sidebar-stat-item">
                        <div class="sidebar-stat-content">
                            <span class="sidebar-stat-label">Available</span>
                            <span class="sidebar-stat-value" id="sidebar-available">$0.00</span>
                        </div>
                    </div>
                    <div class="sidebar-stat-item">
                        <div class="sidebar-stat-content">
                            <span class="sidebar-stat-label">USDH</span>
                            <span class="sidebar-stat-value" id="sidebar-usdh">$0.00</span>
                        </div>
                    </div>
                    <div class="sidebar-stat-item">
                        <div class="sidebar-stat-content">
                            <span class="sidebar-stat-label">Margin</span>
                            <span class="sidebar-stat-value" id="sidebar-margin">$0.00</span>
                        </div>
                    </div>
                    <div class="sidebar-stat-item">
                        <div class="sidebar-stat-content">
                            <span class="sidebar-stat-label">PNL</span>
                            <span class="sidebar-stat-value" id="sidebar-pnl">$0.00</span>
                        </div>
                    </div>
                    <div class="sidebar-stat-item">
                        <div class="sidebar-stat-content">
                            <span class="sidebar-stat-label">Open Int.</span>
                            <span class="sidebar-stat-value" id="sidebar-open-interest">$0.00</span>
                        </div>
                    </div>
                </div>
            </div>
        `;

        // Start time update
        this.startTimeUpdate();

        // Apply initial collapsed state
        this.applyCollapsedState();

        // Re-register mode switcher events for sidebar buttons (if ModeManager is initialized)
        if (window.ModeManager) {
            window.ModeManager.setupModeSwitcherEvents();
        }
    }

    /**
     * Setup event listeners
     */
    setupEventListeners() {
        const sidebar = document.getElementById('left-sidebar');
        if (!sidebar) return;

        sidebar.addEventListener('click', (e) => {
            const tab = e.target.closest('.sidebar-tab');
            if (tab) {
                // Allow browser default behavior for special clicks (opens in new tab)
                // Ctrl+Click (Windows/Linux), Cmd+Click (Mac), or Middle Click
                if (e.ctrlKey || e.metaKey || e.button === 1) {
                    // Let browser handle - will open in new tab using href
                    return;
                }
                
                // Normal left-click - prevent default and do SPA navigation
                e.preventDefault();
                const tabId = tab.dataset.tab;
                this.setActiveTabWithCallback(tabId);
            }

            // Handle toggle button click
            const toggleBtn = e.target.closest('#sidebar-toggle-btn');
            if (toggleBtn) {
                this.toggleCollapse();
            }
        });
        
        // Handle middle mouse button click (auxclick event)
        sidebar.addEventListener('auxclick', (e) => {
            if (e.button === 1) { // Middle mouse button
                const tab = e.target.closest('.sidebar-tab');
                if (tab) {
                    // Let browser handle - will open in new tab using href
                    return;
                }
            }
        });

        // Handle mobile toggle button
        const mobileToggleBtn = document.querySelector('.mobile-sidebar-toggle');
        if (mobileToggleBtn) {
            mobileToggleBtn.addEventListener('click', () => {
                this.toggleMobileSidebar();
            });
        }

        // Listen for credential updates to refresh settings bubble immediately
        document.addEventListener('app:credentials-updated', () => {
            if (this.checkSettingsRequirement) {
                this.checkSettingsRequirement();
            }
        });
    }

    /**
     * Toggle sidebar collapse state
     */
    toggleCollapse() {
        this.isCollapsed = !this.isCollapsed;
        localStorage.setItem('sidebarCollapsed', this.isCollapsed.toString());
        this.applyCollapsedState();

        // Update button title
        const toggleBtn = document.getElementById('sidebar-toggle-btn');
        if (toggleBtn) {
            toggleBtn.title = this.isCollapsed ? 'Expand sidebar' : 'Collapse sidebar';
            // Update arrow direction
            const svg = toggleBtn.querySelector('svg path');
            if (svg) {
                svg.setAttribute('d', this.isCollapsed ? 'M9 18l6-6-6-6' : 'M15 18l-6-6 6-6');
            }
        }
    }

    /**
     * Toggle mobile sidebar visibility
     */
    toggleMobileSidebar() {
        if (!this.isMobile) return;

        this.mobileHidden = !this.mobileHidden;
        localStorage.setItem('sidebarMobileHidden', this.mobileHidden.toString());

        const sidebar = document.getElementById('left-sidebar');
        const mainContent = document.getElementById('main-content');
        const footer = document.querySelector('.app-footer');

        if (sidebar) {
            if (this.mobileHidden) {
                sidebar.classList.add('mobile-hidden');
                if (mainContent) {
                    mainContent.style.marginLeft = '0';
                }
                if (footer) {
                    footer.style.left = '0';
                }
            } else {
                sidebar.classList.remove('mobile-hidden');
                if (mainContent) {
                    mainContent.style.marginLeft = '60px';
                }
                if (footer) {
                    footer.style.left = '60px';
                }
            }
        }
    }

    /**
     * Apply collapsed state to sidebar and adjust layout
     */
    applyCollapsedState() {
        const sidebar = document.getElementById('left-sidebar');
        if (!sidebar) return;

        // Force collapsed on mobile
        if (this.isMobile) {
            this.isCollapsed = true;
            sidebar.classList.add('collapsed');

            // Apply mobile hidden state
            if (this.mobileHidden) {
                sidebar.classList.add('mobile-hidden');
            } else {
                sidebar.classList.remove('mobile-hidden');
            }
        }

        const mainContent = document.getElementById('main-content');
        const footer = document.querySelector('.app-footer');
        const toggleBtn = document.getElementById('sidebar-toggle-btn');

        // Hide toggle button on mobile
        if (this.isMobile && toggleBtn) {
            toggleBtn.style.display = 'none';
        }

        if (this.isCollapsed) {
            sidebar.classList.add('collapsed');
            if (mainContent) {
                mainContent.style.marginLeft = this.isMobile && this.mobileHidden ? '0' : '60px';
            }
            if (footer) {
                footer.style.left = '60px';
            }
        } else {
            sidebar.classList.remove('collapsed');
            if (mainContent) {
                mainContent.style.marginLeft = '220px';
            }
            if (footer) {
                footer.style.left = '220px';
            }
        }

        // Dispatch event for other components to adjust
        window.dispatchEvent(new CustomEvent('sidebar-toggle', {
            detail: { collapsed: this.isCollapsed }
        }));
    }

    /**
     * Set active tab (visual update only, no callback)
     * Used by NavigationManager after navigation completes
     * @param {string} tabId - Tab identifier
     */
    setActiveTab(tabId) {
        if (this.activeTab === tabId) return;

        // Update visual state only - do NOT trigger onTabChange
        // onTabChange is only triggered by user clicks (see setActiveTabWithCallback)
        document.querySelectorAll('.sidebar-tab').forEach(tab => {
            tab.classList.toggle('active', tab.dataset.tab === tabId);
        });

        this.activeTab = tabId;
    }

    /**
     * Set active tab AND trigger navigation callback
     * Used by click handlers to initiate navigation
     * @param {string} tabId - Tab identifier
     */
    setActiveTabWithCallback(tabId) {
        if (this.activeTab === tabId) return;

        // Update visual state
        document.querySelectorAll('.sidebar-tab').forEach(tab => {
            tab.classList.toggle('active', tab.dataset.tab === tabId);
        });

        this.activeTab = tabId;

        // Hide settings bubble if user manually navigates to settings
        if (tabId === 'settings') {
            this.removeSettingsBubble();
        }

        // Notify parent component to trigger navigation
        if (this.onTabChange) {
            this.onTabChange(tabId);
        }
    }

    /**
     * Update connection status indicator
     * @param {string} status - Connection status
     */
    updateConnectionStatus(status) {
        const dot = document.getElementById('sidebar-status-dot');
        const text = document.getElementById('sidebar-status-text');

        if (!dot || !text) return;

        dot.className = `status-dot ${status}`;

        switch (status) {
            case 'connected':
                text.textContent = 'Connected';
                break;
            case 'connecting':
                text.textContent = 'Connecting...';
                break;
            case 'disconnected':
                text.textContent = 'Disconnected';
                break;
            case 'error':
                text.textContent = 'Connection Error';
                break;
            default:
                text.textContent = 'Unknown';
        }
    }

    /**
     * Get current active tab
     * @returns {string} - Active tab ID
     */
    getActiveTab() {
        return this.activeTab;
    }

    /**
     * Set tab change callback
     * @param {Function} callback - Callback function
     */
    onTabChanged(callback) {
        this.onTabChange = callback;
    }

    /**
     * Render tabs with section headers
     * Filters tabs based on current mode (hyperliquid/lighter)
     */
    renderTabsWithSections() {
        let html = '';
        let currentSection = null;

        // Get current mode from ModeManager
        const currentMode = window.ModeManager?.currentMode || 'hyperliquid';

        // Filter tabs based on current mode
        const filteredTabs = this.tabs.filter(tab => tab.mode === currentMode);

        filteredTabs.forEach(tab => {
            // Render section header (without icon)
            if (tab.section && !tab.id) {
                html += `
                    <div class="sidebar-section">
                        <span class="sidebar-section-title">${tab.section}</span>
                    </div>
                `;
                currentSection = tab.section;
            }

            // Render regular tab
            if (tab.id) {
                // Use SVG icon if provided, otherwise use PNG icon
                const iconHtml = tab.iconSvg
                    ? `<span class="tab-icon tab-icon-svg">${tab.iconSvg}</span>`
                    : `<img src="${tab.icon}" class="tab-icon" alt="">`;

                html += `
                    <a href="/${tab.id}" 
                       class="sidebar-tab ${tab.id === this.activeTab ? 'active' : ''}" 
                       data-tab="${tab.id}">
                        ${iconHtml}
                        <span class="tab-label">${tab.label}</span>
                        ${this.renderTabIndicators(tab)}
                    </a>
                `;
            }
        });

        return html;
    }

    /**
     * Render tab indicators (badges, dots, status)
     */
    renderTabIndicators(tab) {
        let indicators = '';

        // Show badge (count)
        if (tab.showBadge) {
            const count = this.badgeData[tab.showBadge] || 0;
            indicators += `<span class="tab-badge ${count === 0 ? 'hidden' : ''}" id="badge-${tab.id}">${count}</span>`;
        }

        // Show status dot
        if (tab.showDot) {
            indicators += `<span class="tab-dot" id="dot-${tab.id}"></span>`;
        }

        // Show status toggle
        if (tab.showStatus === 'toggle') {
            // Determine which status to check based on tab ID
            let isEnabled = false;
            if (tab.id.includes('stablecoin-mm')) {
                isEnabled = this.statusData.stablecoinMM;
            } else if (tab.id.includes('auto-trade')) {
                isEnabled = this.statusData.autoTrade;
            }

            const status = isEnabled ? 'ON' : 'OFF';
            const statusClass = isEnabled ? (tab.id.includes('auto-trade') && this.statusData.autoTradeMode === 'hard' ? 'hard-mode' : 'on') : '';
            indicators += `<span class="tab-status ${statusClass}" id="status-${tab.id}">${status}</span>`;
        }

        // Show checkmark for active
        if (tab.showStatus === 'bot') {
            indicators += `<span class="tab-checkmark ${!this.statusData.bot ? 'hidden' : ''}" id="check-${tab.id}">✓</span>`;
        }

        return indicators;
    }

    /**
     * Update badge counts - mode-aware (Hyperliquid vs Lighter)
     */
    updateBadges(data, mode = 'hyperliquid') {
        // Hyperliquid badges
        if (mode === 'hyperliquid') {
            if (data.positions !== undefined) {
                this.badgeData.positions = data.positions;
                const badge = document.getElementById('badge-terminal');
                if (badge) {
                    badge.textContent = data.positions;
                    badge.classList.toggle('hidden', data.positions === 0);
                }
            }

            if (data.notifications !== undefined) {
                this.badgeData.notifications = data.notifications;
                const badge = document.getElementById('badge-user-feed');
                if (badge) {
                    badge.textContent = data.notifications;
                    badge.classList.toggle('hidden', data.notifications === 0);
                }
            }

            if (data.incomingTrades !== undefined) {
                this.badgeData.incomingTrades = data.incomingTrades;
                const badge = document.getElementById('badge-trades');
                if (badge) {
                    badge.textContent = data.incomingTrades;
                    badge.classList.toggle('hidden', data.incomingTrades === 0);
                }
            }

            if (data.activeBots !== undefined) {
                this.badgeData.activeBots = data.activeBots;
                const badge = document.getElementById('badge-bots');
                if (badge) {
                    badge.textContent = data.activeBots;
                    badge.classList.toggle('hidden', data.activeBots === 0);
                }
            }

            if (data.chaseCount !== undefined) {
                this.badgeData.chaseCount = data.chaseCount;
                const badge = document.getElementById('badge-user-feed');
                if (badge) {
                    badge.textContent = data.chaseCount;
                    badge.classList.toggle('hidden', data.chaseCount === 0);
                }
            }
        }

        // Lighter badges
        if (mode === 'lighter') {
            if (data.positions !== undefined) {
                this.badgeData.lighterPositions = data.positions;
                const badge = document.getElementById('badge-lighter-terminal');
                if (badge) {
                    badge.textContent = data.positions;
                    badge.classList.toggle('hidden', data.positions === 0);
                }
            }

            if (data.incomingTrades !== undefined) {
                this.badgeData.lighterIncomingTrades = data.incomingTrades;
                const badge = document.getElementById('badge-lighter-signals');
                if (badge) {
                    badge.textContent = data.incomingTrades;
                    badge.classList.toggle('hidden', data.incomingTrades === 0);
                }
            }

            if (data.activeBots !== undefined) {
                this.badgeData.lighterActiveBots = data.activeBots;
                const badge = document.getElementById('badge-lighter-bots');
                if (badge) {
                    badge.textContent = data.activeBots;
                    badge.classList.toggle('hidden', data.activeBots === 0);
                }
            }

            if (data.chaseCount !== undefined) {
                this.badgeData.lighterChaseCount = data.chaseCount;
                const badge = document.getElementById('badge-lighter-orders');
                if (badge) {
                    badge.textContent = data.chaseCount;
                    badge.classList.toggle('hidden', data.chaseCount === 0);
                }
            }
        }
    }

    /**
     * Update status indicators - mode-aware (Hyperliquid vs Lighter)
     */
    updateStatus(data, mode = 'hyperliquid') {
        // Hyperliquid status indicators
        if (mode === 'hyperliquid') {
            if (data.bot !== undefined) {
                this.statusData.bot = data.bot;
                const check = document.getElementById('check-bots');
                if (check) {
                    check.classList.toggle('hidden', !data.bot);
                }
            }

            if (data.autoTrade !== undefined) {
                this.statusData.autoTrade = data.autoTrade;

                if (data.autoTradeMode !== undefined) {
                    this.statusData.autoTradeMode = data.autoTradeMode;
                }

                const status = document.getElementById('status-auto-trade');
                if (status) {
                    status.textContent = data.autoTrade ? 'ON' : 'OFF';
                    status.classList.remove('on', 'hard-mode');
                    if (data.autoTrade) {
                        if (this.statusData.autoTradeMode === 'hard') {
                            status.classList.add('hard-mode');
                        } else {
                            status.classList.add('on');
                        }
                    }
                }
            }

            if (data.stablecoinMM !== undefined) {
                this.statusData.stablecoinMM = data.stablecoinMM;
                const status = document.getElementById('status-stablecoin-mm');
                if (status) {
                    status.textContent = data.stablecoinMM ? 'ON' : 'OFF';
                    status.classList.remove('on');
                    if (data.stablecoinMM) {
                        status.classList.add('on');
                    }
                }
            }
        }

        // Lighter status indicators
        if (mode === 'lighter') {
            if (data.bot !== undefined) {
                this.statusData.lighterBot = data.bot;
                const check = document.getElementById('check-lighter-bots');
                if (check) {
                    check.classList.toggle('hidden', !data.bot);
                }
            }

            if (data.autoTrade !== undefined) {
                this.statusData.lighterAutoTrade = data.autoTrade;

                if (data.autoTradeMode !== undefined) {
                    this.statusData.lighterAutoTradeMode = data.autoTradeMode;
                }

                const status = document.getElementById('status-lighter-auto-trade');
                if (status) {
                    status.textContent = data.autoTrade ? 'ON' : 'OFF';
                    status.classList.remove('on', 'hard-mode');
                    if (data.autoTrade) {
                        if (this.statusData.lighterAutoTradeMode === 'hard') {
                            status.classList.add('hard-mode');
                        } else {
                            status.classList.add('on');
                        }
                    }
                }
            }

            if (data.stablecoinMM !== undefined) {
                this.statusData.lighterStablecoinMM = data.stablecoinMM;
                const status = document.getElementById('status-lighter-stablecoin-mm');
                if (status) {
                    status.textContent = data.stablecoinMM ? 'ON' : 'OFF';
                    status.classList.remove('on');
                    if (data.stablecoinMM) {
                        status.classList.add('on');
                    }
                }
            }
        }
    }

    /**
     * Setup listener for positions data to update account value
     * Supports both Hyperliquid and Lighter modes
     */
    setupPositionsListener() {
        const isElectron = window.process?.versions?.electron;

        if (isElectron && window.electronAPI?.on) {
            // Electron mode: Listen to IPC events
            this.positionsDataHandler = (data) => {
                // Only process if we're in Hyperliquid mode
                const currentMode = window.ModeManager?.currentMode || 'hyperliquid';
                if (currentMode === 'hyperliquid' && data && data.accountSummary) {
                    // Store both account summary AND positions
                    this.currentAccountSummary = data.accountSummary;
                    this.currentPositions = data.positions || [];

                    // Update display with full data
                    this.updateAccountSummary(data.accountSummary, this.currentPositions);
                }
            };
            window.electronAPI.on('positions-data', this.positionsDataHandler);
        } else {
            // Browser mode: Listen to CustomEvent from BrowserPositionTracker
            this.positionsDataHandler = (event) => {
                const data = event.detail;
                // Only process if we're in Hyperliquid mode
                const currentMode = window.ModeManager?.currentMode || 'hyperliquid';
                if (currentMode === 'hyperliquid' && data && data.accountSummary) {
                    // console.log('[LEFT-SIDEBAR] Received Hyperliquid account data');

                    // Store both account summary AND positions
                    this.currentAccountSummary = data.accountSummary;
                    this.currentPositions = data.positions || [];

                    // Update display with full data
                    this.updateAccountSummary(data.accountSummary, this.currentPositions);

                    // Also update global cache for other components
                    window.lastPositionsData = {
                        accountSummary: data.accountSummary,
                        positions: data.positions,
                        timestamp: data.timestamp || Date.now()
                    };
                }
            };
            window.addEventListener('positions-data', this.positionsDataHandler);
            // console.log('[LEFT-SIDEBAR] Listening to positions-data CustomEvent');
        }

        // LIGHTER MODE: Subscribe to Lighter GlobalDataManager
        this.setupLighterDataListener();
    }

    /**
     * Start time update interval
     */
    startTimeUpdate() {
        const updateTime = () => {
            const timeElement = document.getElementById('sidebar-time');
            if (timeElement) {
                const now = new Date();
                timeElement.textContent = now.toLocaleTimeString('en-US', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true
                });
            }
        };

        updateTime(); // Initial update
        setInterval(updateTime, 1000); // Update every second
    }

    /**
     * Start periodic status updates for bot indicators
     */
    startStatusUpdates() {
        // Update immediately
        this.refreshBotStatus();

        // Then update every 5 seconds
        this.statusUpdateInterval = setInterval(() => {
            this.refreshBotStatus();
        }, 5000);
    }

    /**
     * Setup listener for Lighter data updates
     */
    setupLighterDataListener() {
        // Subscribe to Lighter GlobalDataManager when it's available
        if (window.ModeManager?.lighterGlobalDataManager) {
            this.lighterUnsubscribe = window.ModeManager.lighterGlobalDataManager.subscribe((data) => {
                // Only process if we're in Lighter mode
                const currentMode = window.ModeManager?.currentMode || 'hyperliquid';
                if (currentMode === 'lighter' && data) {
                    this.updateLighterAccountSummary(data);
                }
            });
        }

        // Also listen for mode changes to refresh data
        window.addEventListener('mode-changed', (event) => {
            const newMode = event.detail?.mode;
            if (newMode === 'lighter') {
                // Request fresh Lighter data
                if (window.ModeManager?.lighterGlobalDataManager) {
                    const data = window.ModeManager.lighterGlobalDataManager.getLatestData();
                    if (data) {
                        this.updateLighterAccountSummary(data);
                    }
                }
            } else if (newMode === 'hyperliquid') {
                // Request fresh Hyperliquid data
                if (window.lastPositionsData && window.lastPositionsData.accountSummary) {
                    this.updateAccountSummary(window.lastPositionsData.accountSummary, window.lastPositionsData.positions || []);
                }
            }
        });
    }

    /**
     * Update account summary with Lighter data
     */
    updateLighterAccountSummary(lighterData) {
        if (!lighterData) return;

        // Extract Lighter account values from GlobalDataManager structure
        const accountSummary = lighterData.accountSummary || {};
        const positions = lighterData.positions || [];

        const accountValue = accountSummary.accountValue || 0;
        const availableBalance = accountSummary.available || 0;
        const marginUsed = accountSummary.marginUsed || 0;
        const totalPnl = accountSummary.unrealizedPnl || 0;
        const openInterest = accountSummary.openInterest || 0;

        // Update DOM elements
        const accountValueEl = document.getElementById('sidebar-account-value');
        const availableEl = document.getElementById('sidebar-available');
        const usdhEl = document.getElementById('sidebar-usdh');
        const marginEl = document.getElementById('sidebar-margin');
        const pnlEl = document.getElementById('sidebar-pnl');
        const openIntEl = document.getElementById('sidebar-open-interest');

        if (accountValueEl) accountValueEl.textContent = accountValue.toFixed(2);
        if (availableEl) availableEl.textContent = availableBalance.toFixed(2);
        if (usdhEl) usdhEl.textContent = '0.00'; // Lighter doesn't use USDH
        if (marginEl) marginEl.textContent = marginUsed.toFixed(2);

        if (pnlEl) {
            pnlEl.textContent = totalPnl.toFixed(2);
            pnlEl.className = 'sidebar-stat-value';
            if (totalPnl > 0) pnlEl.classList.add('profit');
            else if (totalPnl < 0) pnlEl.classList.add('loss');
        }

        if (openIntEl) openIntEl.textContent = openInterest.toFixed(2);
    }

    /**
     * DEPRECATED: No longer needed - we listen to positions-data CustomEvent directly
     * Keeping for backwards compatibility but not called
     */
    async refreshAccountValue() {
        try {
            // Use global cached data if available
            if (window.lastPositionsData && window.lastPositionsData.accountSummary) {
                this.currentAccountSummary = window.lastPositionsData.accountSummary;
                this.currentPositions = window.lastPositionsData.positions || [];
                this.updateAccountSummary(this.currentAccountSummary, this.currentPositions);
            }
        } catch (error) {
            // Silently fail on first load
            console.error('[LEFT-SIDEBAR] Error refreshing account:', error);
        }
    }

    /**
     * Refresh bot status from main process (Electron) or browser services (Browser)
     */
    async refreshBotStatus() {
        const isElectron = window.process?.versions?.electron;

        try {
            // Get auto trade status (works in both Electron and Browser via IPC compatibility layer)
            // This is Hyperliquid-specific for now
            const autoTradeResult = await window.electronAPI.invoke('autoTrade:getStatus');
            if (autoTradeResult.success && autoTradeResult.status) {
                this.updateStatus({
                    autoTrade: autoTradeResult.status.enabled || false,
                    autoTradeMode: autoTradeResult.status.mode || 'easy'
                }, 'hyperliquid');
            }

            // Count active bots
            let activeBotCount = 0;

            // Get bot cancellation status (DUAL MODE)
            if (!isElectron) {
                // Browser mode - check BrowserCancellationBot directly
                if (window.BrowserCancellationBot) {
                    const status = window.BrowserCancellationBot.getStatus();
                    if (status.enabled) {
                        activeBotCount++;
                    }
                }
            } else {
                // Electron mode - use IPC
                try {
                    const botResult = await window.electronAPI.invoke('bot:getCancellationStatus');
                    if (botResult.success && botResult.status && botResult.status.enabled) {
                        activeBotCount++;
                    }
                } catch (e) {
                    // Bot cancellation IPC failed
                }
            }

            // Check if auto trade is also a "bot"
            if (autoTradeResult.success && autoTradeResult.status && autoTradeResult.status.enabled) {
                activeBotCount++;
            }

            // Check trailing SL bot (DUAL MODE)
            if (!isElectron) {
                // Browser mode - check BrowserTrailingSLBot directly
                if (window.BrowserTrailingSLBot) {
                    const status = window.BrowserTrailingSLBot.getStatus();
                    if (status.enabled) {
                        activeBotCount++;
                    }
                }
            } else {
                // Electron mode - use IPC
                try {
                    const trailingSLResult = await window.electronAPI.invoke('trailingSL:getStatus');
                    if (trailingSLResult.success && trailingSLResult.status && trailingSLResult.status.enabled) {
                        activeBotCount++;
                    }
                } catch (e) {
                    // Trailing SL might not be available
                }
            }

            // Check Position Defense bot (LocalStorage only for now)
            try {
                const saved = localStorage.getItem('positionDefenseBotSettings');
                if (saved) {
                    const data = JSON.parse(saved);
                    if (data.enabled) {
                        activeBotCount++;
                    }
                }
            } catch (e) {
                // Position Defense might not be configured
            }

            // Check StableCoin MM bot status (for toggle badge on its dedicated page)
            // DON'T count it in activeBots since it has its own dedicated page
            if (window.SpotHandler) {
                try {
                    const status = window.SpotHandler.getStatus();
                    const isEnabled = status.enabled || false;

                    // DON'T add to activeBotCount - it has dedicated page
                    // if (isEnabled) {
                    //     activeBotCount++;
                    // }

                    // Update StableCoin MM status toggle badge (still needed for its own page)
                    this.updateStatus({
                        stablecoinMM: isEnabled
                    }, 'hyperliquid');
                } catch (e) {
                    // SpotHandler might not be ready
                    this.updateStatus({
                        stablecoinMM: false
                    }, 'hyperliquid');
                }
            } else {
                this.updateStatus({
                    stablecoinMM: false
                }, 'hyperliquid');
            }

            // Update Hyperliquid bot count badge
            this.updateBadges({
                activeBots: activeBotCount
            }, 'hyperliquid');

            // Get incoming trades count from TradeDataManager (for Hyperliquid)
            if (window.TradeDataManager) {
                try {
                    const incomingTrades = window.TradeDataManager.getIncomingTrades();
                    if (incomingTrades && Array.isArray(incomingTrades)) {
                        this.updateBadges({
                            incomingTrades: incomingTrades.length
                        }, 'hyperliquid');
                        // Also update Lighter signals badge (same data source for now)
                        this.updateBadges({
                            incomingTrades: incomingTrades.length
                        }, 'lighter');
                    }
                } catch (e) {
                    // TradeDataManager might not be ready
                }
            }

            // Update Lighter-specific badges (placeholder - 0 for now until Lighter bots implemented)
            this.updateBadges({
                activeBots: 0  // Lighter bots not yet implemented
            }, 'lighter');

            this.updateStatus({
                autoTrade: false,  // Lighter auto-trade not yet implemented
                stablecoinMM: false  // Lighter stablecoin MM not yet implemented
            }, 'lighter');

        } catch (error) {
            // Silently fail - don't spam console during normal operation
            // console.debug('Sidebar status update error:', error);
        }
    }

    /**
     * Update complete account summary display
     */
    updateAccountSummary(accountSummary, positions = []) {
        if (!accountSummary) return;

        // Extract values from account summary
        const accountValue = parseFloat(accountSummary.accountValue || 0);
        // Use availableForTrading (correct for isolated margin) with fallback to withdrawable
        const availableForTrading = accountSummary.availableForTrading ?? accountSummary.withdrawable ?? 0;
        const usdhBalance = parseFloat(accountSummary.usdhBalance || 0);
        const marginUsed = parseFloat(accountSummary.marginUsed || 0);

        // Calculate from positions
        const totalPnl = positions.reduce((sum, pos) => sum + (pos.unrealizedPnl || 0), 0);
        const openInterest = positions.reduce((sum, pos) => {
            return sum + (Math.abs(pos.size) * pos.entryPrice);
        }, 0);

        // Update DOM elements
        const accountValueEl = document.getElementById('sidebar-account-value');
        const availableEl = document.getElementById('sidebar-available');
        const usdhEl = document.getElementById('sidebar-usdh');
        const marginEl = document.getElementById('sidebar-margin');
        const pnlEl = document.getElementById('sidebar-pnl');
        const openIntEl = document.getElementById('sidebar-open-interest');

        if (accountValueEl) accountValueEl.textContent = accountValue.toFixed(2);
        if (availableEl) availableEl.textContent = parseFloat(availableForTrading).toFixed(2);
        if (usdhEl) usdhEl.textContent = usdhBalance.toFixed(2);
        if (marginEl) marginEl.textContent = marginUsed.toFixed(2);

        if (pnlEl) {
            pnlEl.textContent = totalPnl.toFixed(2);
            pnlEl.className = 'sidebar-stat-value';
            if (totalPnl > 0) pnlEl.classList.add('profit');
            else if (totalPnl < 0) pnlEl.classList.add('loss');
        }

        if (openIntEl) openIntEl.textContent = openInterest.toFixed(2);

        // Update asset balances list
        this.updateAssetBalances(positions, accountSummary);
    }

    /**
     * Update asset balances list - only show actual holdings (no positions)
     */
    updateAssetBalances(positions = [], accountSummary = null) {
        const assetList = document.getElementById('sidebar-asset-list');
        if (!assetList) return;

        // Clear and rebuild asset balances map
        this.allAssetBalances.clear();
        
        // Add USDC from perps (total balance including cross + isolated margin)
        if (accountSummary && accountSummary.accountValue) {
            this.allAssetBalances.set('USDC (Perps)', {
                balance: parseFloat(accountSummary.accountValue),
                type: 'perp',
                symbol: 'USDC'
            });
        }

        // Add USDH from spot (only once)
        if (accountSummary && accountSummary.usdhBalance) {
            this.allAssetBalances.set('USDH', {
                balance: parseFloat(accountSummary.usdhBalance),
                type: 'spot',
                symbol: 'USDH'
            });
        }

        // Fetch other spot token balances (ETH, BTC, PURR, etc.)
        if (window.BrowserHyperliquidClient && window.BrowserHyperliquidClient.isInitialized) {
            this.fetchAndUpdateSpotBalances();
        } else {
            // Render with what we have (USDC + USDH)
            this.renderAssetList();
        }
    }

    /**
     * Fetch spot balances and update asset list
     */
    async fetchAndUpdateSpotBalances() {
        try {
            const spotState = await window.BrowserHyperliquidClient.getSpotBalance();
            if (spotState && spotState.balances) {
                spotState.balances.forEach(bal => {
                    const balance = parseFloat(bal.total || 0);
                    if (balance > 0 && bal.coin !== 'USDH') { // USDH already added
                        const key = `${bal.coin} (Spot)`;
                        this.allAssetBalances.set(key, {
                            balance: balance,
                            type: 'spot',
                            symbol: bal.coin
                        });
                    }
                });

                // Re-render with new spot data
                this.renderAssetList();
            }
        } catch (error) {
            // Silently fail - spot balances are nice-to-have
        }
    }

    /**
     * Render the asset balances list (holdings only)
     */
    renderAssetList() {
        const assetList = document.getElementById('sidebar-asset-list');
        if (!assetList) return;

        // Sort assets: USDC first, then USDH, then alphabetically
        const sortedAssets = Array.from(this.allAssetBalances.entries())
            .sort((a, b) => {
                if (a[0].includes('USDC (Perps)')) return -1;
                if (b[0].includes('USDC (Perps)')) return 1;
                if (a[0] === 'USDH') return -1;
                if (b[0] === 'USDH') return 1;
                return a[0].localeCompare(b[0]);
            });

        // Render asset items
        assetList.innerHTML = sortedAssets.map(([name, data]) => {
            const typeClass = data.type === 'spot' ? 'asset-type-spot' : 'asset-type-perp';

            // Check if stablecoin (USDC, USDH, USDT, USDE, etc.)
            const isStablecoin = /^USD[A-Z]?$/i.test(data.symbol);

            // Format balance
            let formattedBalance;
            if (isStablecoin) {
                // Stablecoins: 2 decimal places
                formattedBalance = data.balance.toFixed(2);
            } else {
                // Non-stablecoins: 6 significant digits
                formattedBalance = this.formatToSigFigs(data.balance, 6);
            }

            const balanceStr = `${formattedBalance} ${data.symbol}`;

            return `
                <div class="asset-balance-item ${typeClass}">
                    <span class="asset-name">${name}</span>
                    <span class="asset-balance">${balanceStr}</span>
                </div>
            `;
        }).join('');
    }

    /**
     * Format number to specified significant figures
     */
    formatToSigFigs(num, sigFigs) {
        if (num === 0) return '0';

        const magnitude = Math.floor(Math.log10(Math.abs(num)));
        const scale = Math.pow(10, sigFigs - 1 - magnitude);
        const rounded = Math.round(num * scale) / scale;

        // Convert to string and remove trailing zeros after decimal
        let str = rounded.toString();
        if (str.includes('.')) {
            str = str.replace(/\.?0+$/, '');
        }

        return str;
    }

    /**
     * DEPRECATED: Kept for backwards compatibility
     * Use updateAccountSummary() instead
     */
    updateAccountValue(accountValue) {
        const valueElement = document.getElementById('sidebar-account-value');
        if (valueElement && accountValue !== undefined) {
            valueElement.textContent = parseFloat(accountValue).toFixed(2);
        }
    }

    /**
     * Setup chase count listener (using dashboard's method)
     */
    setupChaseListener() {
        // Update chase count immediately
        this.updateChaseCount();

        // Listen for chase events
        window.addEventListener('chase-started', () => this.updateChaseCount());
        window.addEventListener('chase-stopped', () => this.updateChaseCount());

        // Also update periodically (in case of edge cases)
        setInterval(() => this.updateChaseCount(), 5000);
    }

    /**
     * Update chase count badge (using dashboard's method)
     */
    updateChaseCount() {
        // Read from BrowserChaseTracker
        if (window.BrowserChaseTracker && window.BrowserChaseTracker.activeChases) {
            const activeChases = window.BrowserChaseTracker.activeChases.size;
            this.badgeData.chaseCount = activeChases;

            const badge = document.getElementById('badge-user-feed');
            if (badge) {
                badge.textContent = activeChases;
                badge.classList.toggle('hidden', activeChases === 0);
            }
        } else {
            // Chase tracker not ready yet, show 0
            this.badgeData.chaseCount = 0;
            const badge = document.getElementById('badge-user-feed');
            if (badge) {
                badge.textContent = '0';
                badge.classList.add('hidden');
            }
        }
    }

    /**

     * Check if settings requirement (API key) is missing and show bubble
     */
    checkSettingsRequirement() {
        // Don't show if currently on settings tab
        if (this.activeTab === 'settings' || this.activeTab === 'lighter-settings') {
            this.removeSettingsBubble();
            return;
        }

        // Check if PasswordManager is available
        if (!window.PasswordManager) {
            return;
        }

        // Show bubble if API key is NOT stored
        if (!window.PasswordManager.hasStoredApiKey()) {
            this.showSettingsBubble();
        } else {
            this.removeSettingsBubble();
        }
    }

    /**
     * Show the settings bubble prompt
     */
    showSettingsBubble() {
        // Prevent duplicates
        if (document.querySelector('.settings-bubble')) {
            return;
        }

        const settingsTab = document.querySelector('.sidebar-tab[data-tab="settings"]') ||
            document.querySelector('.sidebar-tab[data-tab="lighter-settings"]');
        if (!settingsTab) return;

        // First scroll the settings tab into view
        settingsTab.scrollIntoView({ behavior: 'instant', block: 'center' });

        // Create bubble
        const bubble = document.createElement('div');
        bubble.className = 'settings-bubble';
        bubble.innerHTML = '<span class="hand-pointer">👈</span> Set API key here';

        // Position fixed to break out of sidebar overflow
        // Start OFF-SCREEN to prevent any bottom-left flicker
        bubble.style.position = 'fixed';
        bubble.style.zIndex = '9999';
        bubble.style.left = '-9999px';
        bubble.style.top = '-9999px';

        document.body.appendChild(bubble);

        // Robust update function
        const updatePosition = () => {
            if (!settingsTab || !bubble) return;

            // 1. Try targeting the label (expanded state)
            let target = settingsTab.querySelector('.tab-label');
            let rect = target ? target.getBoundingClientRect() : null;

            // 2. If label is hidden (width ~0) or missing, fallback to the TAB itself (collapsed state)
            const isLabelVisible = rect && rect.width > 5;
            if (!isLabelVisible) {
                target = settingsTab;
                rect = target.getBoundingClientRect();
            }

            // Only update if we have valid coordinates (checking dimensions is enough)
            if (rect && rect.width > 0 && rect.height > 0) {
                // Gap adjustment based on what we're targeting
                // If targeting label (expanded): gap is small (12px)
                // If targeting tab (collapsed): bigger gap to clear the icon/padding, but not too big
                // User feedback: "a bit mislocated" -> likely too far right.
                const gap = isLabelVisible ? 12 : 20;

                // Calculate position: Right of the target
                // For collapsed, target is the 'tab' which is 60px wide. 
                // We want it to appear *next* to the icon, which is centered.
                // Icon center is approx at 30px.
                // So if we take rect.right (60px) + gap (20px) = 80px from left edge.
                let leftPos = rect.right + gap;

                // If collapsed, use a tighter gap relative to the actual visual icon if possible
                if (!isLabelVisible) {
                    leftPos = rect.right + 10; // Tighter gap for collapsed state
                }

                const topPos = rect.top + (rect.height / 2);

                bubble.style.left = `${leftPos}px`;
                bubble.style.top = `${topPos}px`;
                // transform is handled by CSS class now, but we need to ensure it doesn't conflict
                // The CSS .visible class handles translateY(-50%)

                // Show if valid position found
                if (!bubble.classList.contains('visible')) {
                    // Small delay to ensure DOM update has processed the position
                    requestAnimationFrame(() => {
                        bubble.classList.add('visible');
                    });
                }
            }
        };

        // 1. Initial update
        requestAnimationFrame(updatePosition);

        // 2. Observer for element resize/move
        this._bubbleObserver = new ResizeObserver(() => {
            requestAnimationFrame(updatePosition);
        });
        this._bubbleObserver.observe(settingsTab);
        this._bubbleObserver.observe(document.body); // Watch body for global layout shifts

        // 3. Polling fallback (every 500ms) to catch any other shifts (zoom, scroll that bypasses observer)
        this._bubbleInterval = setInterval(updatePosition, 500);

        // 4. Scroll listeners and Transition listeners
        const tabsContainer = document.querySelector('.sidebar-tabs');
        if (tabsContainer) {
            tabsContainer.addEventListener('scroll', updatePosition, { passive: true });
        }
        window.addEventListener('resize', updatePosition, { passive: true });
        window.addEventListener('scroll', updatePosition, { passive: true, capture: true });

        // 5. Sidebar specific listeners for Collapse/Expand transitions
        const sidebar = document.getElementById('left-sidebar');
        if (sidebar) {
            // Update when sidebar transition ends (width change complete)
            sidebar.addEventListener('transitionend', updatePosition);

            // Also watch for class changes (collapsed toggle)
            this._sidebarObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === 'class') {
                        // Triggers immediately when class changes, then transitionend handles the end
                        requestAnimationFrame(updatePosition);
                        // Force another check shortly after just in case
                        setTimeout(updatePosition, 350);
                    }
                });
            });
            this._sidebarObserver.observe(sidebar, { attributes: true, attributeFilter: ['class'] });
        }

        // Store cleanup function on the instance to remove listeners later
        this._cleanupBubbleListeners = () => {
            if (this._bubbleObserver) this._bubbleObserver.disconnect();
            if (this._sidebarObserver) this._sidebarObserver.disconnect();
            if (this._bubbleInterval) clearInterval(this._bubbleInterval);
            if (tabsContainer) tabsContainer.removeEventListener('scroll', updatePosition);
            if (sidebar) sidebar.removeEventListener('transitionend', updatePosition);
            window.removeEventListener('resize', updatePosition);
            window.removeEventListener('scroll', updatePosition, { capture: true });
        };
    }

    /**
     * Remove the settings bubble prompt
     */
    removeSettingsBubble() {
        const bubble = document.querySelector('.settings-bubble');
        if (bubble) {
            bubble.remove();
        }

        if (this._cleanupBubbleListeners) {
            this._cleanupBubbleListeners();
            this._cleanupBubbleListeners = null;
        }

        // Legacy cleanup (just in case)
        if (this._bubbleResizeHandler) {
            window.removeEventListener('resize', this._bubbleResizeHandler);
            this._bubbleResizeHandler = null;
        }
    }

    /**
    
     * Setup resize listener to handle mobile/desktop transitions
     */
    setupResizeListener() {
        window.addEventListener('resize', () => {
            const wasMobile = this.isMobile;
            this.isMobile = window.innerWidth <= 768;

            // If switching to mobile, force collapsed
            if (this.isMobile && !wasMobile) {
                this.isCollapsed = true;
                this.applyCollapsedState();
            }
            // If switching from mobile to desktop, respect localStorage
            else if (!this.isMobile && wasMobile) {
                this.isCollapsed = localStorage.getItem('sidebarCollapsed') === 'true';
                this.render(); // Re-render to show/hide toggle button
                this.applyCollapsedState();
            }
        });
    }

    /**
     * Cleanup and remove event listeners
     * MEMORY LEAK FIX: Remove positions-data listener
     */
    destroy() {
        // Clear status update interval
        if (this.statusUpdateInterval) {
            clearInterval(this.statusUpdateInterval);
            this.statusUpdateInterval = null;
        }

        // Remove positions data listener
        if (this.positionsDataHandler) {
            const isElectron = window.process?.versions?.electron;
            if (isElectron && window.electronAPI?.removeListener) {
                window.electronAPI.removeListener('positions-data', this.positionsDataHandler);
            } else {
                window.removeEventListener('positions-data', this.positionsDataHandler);
            }
            this.positionsDataHandler = null;
        }
    }

    /**
     * Check if settings requirement (API key) is missing and show bubble
     */


    /**
     * Refresh sidebar for mode change
     * Re-renders sidebar with filtered tabs for current mode
     */
    refreshForMode() {
        console.log('[SIDEBAR] Refreshing for mode change');

        // Re-render the entire sidebar to show correct tabs
        this.render();

        // Reattach event listeners
        this.setupEventListeners();
    }

    /**
     * DEPRECATED - kept for backwards compatibility
     * Use refreshForMode() instead
     */
    disableTabs(allowedTabs) {
        console.warn('[SIDEBAR] disableTabs is deprecated, use refreshForMode()');
    }

    /**
     * DEPRECATED - kept for backwards compatibility
     * Use refreshForMode() instead
     */
    enableAllTabs() {
        console.warn('[SIDEBAR] enableAllTabs is deprecated, use refreshForMode()');
    }
}
window.LeftSidebar = new LeftSidebar();
export { LeftSidebar };
